import { useEffect, useState } from 'react'
import { listAgents } from '@/lib/api'
import type { Agent } from '@/types'
import { CardGrid, Card } from '@/components/ui/Card'
import { StatusDot } from '@/components/ui/StatusDot'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function TeamView({ metricsTable, title }: { metricsTable: string; title: string }) {
  const [agents, setAgents] = useState<Agent[]>([])

  useEffect(() => {
    listAgents().then((all) => setAgents(all.filter((a) => a.metrics_table === metricsTable)))
  }, [metricsTable])

  return (
    <div>
      <PendingBackendNotice endpoint={`GET /agents?metrics_table=${metricsTable}`} />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Equipo {title}</h1>
      <CardGrid>
        {agents.map((a) => (
          <Card key={a.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{a.name}</div>
              <StatusDot status={a.status} showLabel={false} />
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{a.description}</p>
          </Card>
        ))}
      </CardGrid>
    </div>
  )
}
